import { Collapse } from '@material-ui/core'
import React from 'react'
import { ficur, url_with_new_qp } from '../../../helpers/misc'
import { Box, Text } from '../../Shared/Base'
import { ArrowDown, ArrowUp } from '../../Shared/Svg/List'

const plural = (str, x) => (x > 1 ? `${str}s` : str)

const TenementBlock = ({ tenements, linkContact }) => {
  const [collapsed, set_collapsed] = React.useState(true)
  const { room } = tenements[0]
  const ad_rents = tenements.map(x => x.price)

  const ad_rent = [Math.min(...ad_rents), Math.max(...ad_rents)]
  const ordered_tenements = React.useMemo(() => tenements.sort((a, b) => a.price - b.price), [
    tenements
  ])

  return (
    <Box mt={10}>
      <Box as="button" display="flex" onClick={() => set_collapsed(x => !x)} width="100%">
        <Box
          display="flex"
          flex="1"
          bg="n_tertiary"
          px={20}
          py={10}
          flexDirection="row"
          justifyContent="space-between"
          style={{
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
            borderBottomLeftRadius: collapsed ? 10 : 0,
            borderBottomRightRadius: collapsed ? 10 : 0
          }}
        >
          <Box>
            <Text color="white" fontWeight="700" textAlign="left">
              {`${room} ${plural('pièce', room)}`}
            </Text>
            {ad_rent[0] === ad_rent[1] ? (
              <Text color="white" textAlign="left">
                {ficur(ad_rent[0])}
              </Text>
            ) : (
              <Text color="white" textAlign="left">
                {ficur(ad_rent[0]).replace(' €', '')} à {ficur(ad_rent[1])}
              </Text>
            )}
          </Box>
          <Box display="flex" flexDirection="row" alignItems="center">
            <Text color="white" mr={10} fontWeight="700">
              {tenements.length} {plural('bien', tenements.length)}
            </Text>
            {!collapsed ? <ArrowUp /> : <ArrowDown />}
          </Box>
        </Box>
      </Box>
      <Collapse in={!collapsed}>
        {ordered_tenements.map((t, i) => (
          <Box
            display="flex"
            py={10}
            px={20}
            key={i}
            flexDirection="row"
            alignItems="center"
            bg={i % 2 === 1 ? '#D4E9F8' : '#E3F2FD'}
            style={{
              borderBottomLeftRadius: i === ad_rents.length - 1 ? 10 : 0,
              borderBottomRightRadius: i === ad_rents.length - 1 ? 10 : 0
            }}
          >
            <Box>
              <Text color="n_primary">
                {t.type === 'Appartement' ? (t.room > 1 ? `Appartement` : 'Studio') : `Maison`}
              </Text>
              <Text color="n_primary">
                {t.room} {plural('pc', t.room)}{' '}
                <Box as="span" fontSize={12} px="5px" display="inline">
                  •
                </Box>
                {t.area} m²
              </Text>
            </Box>
            <Box display="flex" flex={1} alignItems="flex-end" flexDirection="column">
              <Text color="n_primary">{ficur(t.price)}</Text>
              <Text fontSize={13} color="n_primary">
                {ficur(Math.round(t.price / t.area))} / m²
              </Text>
            </Box>
            <Box
              as="a"
              rel="noopener noreferrer"
              target="_blank"
              display="flex"
              bg="n_primary"
              py="8px"
              px={15}
              borderRadius={5}
              ml={15}
              href={url_with_new_qp(linkContact, 'property_id', t.property_id)}
            >
              <Text color="white">Plan</Text>
            </Box>
          </Box>
        ))}
      </Collapse>
    </Box>
  )
}

const ResultNreTenements = ({ ad, linkContact }) => {
  const linkTotal = React.useMemo(
    () => `${process.env.REACT_APP_API_ENDPOINT.replace('/apiv2', '')}${linkContact}`,
    [linkContact]
  )

  if (!ad.new_real_estate) return null

  const tenements_type_unfiltered = [] // 1  3  4 number_of_rooms
  const tenements_by_type = {
    // t1: [...]
  }
  ad.new_real_estate.properties.forEach(el => {
    tenements_type_unfiltered.push(el.room)
    tenements_by_type[`t${el.room}`] = tenements_by_type[`t${el.room}`] || []
    tenements_by_type[`t${el.room}`].push(el)
  })

  const tenements_type = tenements_type_unfiltered.filter((v, i, a) => a.indexOf(v) === i).sort()

  return (
    <>
      <Text as="h3" className="h3-like" mt={30} mb={20}>
        Logements disponibles
      </Text>

      {tenements_type.map(tt => (
        <TenementBlock key={tt} tenements={tenements_by_type[`t${tt}`]} linkContact={linkTotal} />
      ))}
    </>
  )
}

export default React.memo(ResultNreTenements)
